<template>
	<div class="assets-composition-wrapper" :class="{ 'chart-wrapper-inline': inline }">
		<Loading v-if="loading" v-bind:class="{
            'mt-n4': currentRoute === 'dashboard',
            'mt-5 pt-5': currentRoute === 'assets'}
        "/>
		<div class="text-center" v-if="loading === false && report.length === 0">
			<small class="text-grey">Zloženie majetku neobsahuje žiadne data</small>
		</div>
		<template v-if="loading === false && report.length !== 0">
			<div
				class="chart-wrapper"
				:class="{ 'chart-wrapper-inline': inline }"
				:style="'width: ' + size + 'px; height: ' + size + 'px'"
			>
				<vue-chart
					ref="chart"
					type="doughnut"
					:data="chartData"
					:options="options"
					:height="size"
					:width="size"
				></vue-chart>
				<div class="total-wrapper">
					<strong
						>{{ totalPrice | number }}
						<small>{{ report[0].currency }}</small>
					</strong>
				</div>
			</div>
			<div class="legend-wrapper c-pointer">
				<ul>
					<li v-for="(item, index) in report" v-bind:key="item.eqid" @click="openSlice(index);" v-if="item.eqid === 'Polaris'">
						<span class="dot" :style="'background-color: ' + getColor(index)"></span>
						<span class="name">{{ inline ? getName(item.eqid) : item.eqid }}</span>
						<span class="percent" :title="item.share">{{ inline ? parseInt(item.share) : item.share | number(0) }} %</span>
					</li>
					<li v-for="(item, index) in report" v-bind:key="item.eqid" @click="openSlice(index);" v-if="item.eqid !== 'Polaris'">
						<span class="dot" :style="'background-color: ' + getColor(index)"></span>
						<span class="name">{{ inline ? getName(item.eqid) : item.eqid }}</span>
						<span class="percent" :title="item.share">{{ inline ? parseInt(item.share) : item.share | number(0) }} %</span>
					</li>
				</ul>
			</div>
		</template>
	</div>
</template>
<script>
import VueChart from "vue-chart-js";
import Loading from "./Loading";

export default {
	name: "AssetsComposition",
	components: {
		Loading,
		VueChart,
	},
	props: {
		size: {
			type: Number,
			default: 140,
		},
		inline: {
			type: Boolean,
			default: true,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		onSelect: {
			type: Function,
		},
	},
	watch: {
		report: {
			deep: true,
			handler() {
				this.initGraph();
			},
		},
    portfolio: {
      deep: true,
      handler() {
        this.start = true;
        this.loadData();
      },
    },
	},
	computed: {
		report() {
			return this.$store.state.assets.compositionByAssets;
		},
		portfolio() {
			return this.$store.state.portfolio.selected;
		},
		loading() {
			return this.$store.state.assets.loading;
		},
		currentRoute() {
			return this.$route.name;
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.$store.dispatch("assets/compositionByAssets", this.inline ? {} : {
				portfolioId: this.portfolio ? this.portfolio.portfolio : null
			});
		},
		getColor(index) {
			const colors = this.colors.length;
			const iterations = Math.floor(index / colors);
			const colorIndex = index - iterations * colors;
			return this.colors[colorIndex];
		},
		initGraph() {
			this.totalPrice = 0;
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[0].backgroundColor = [];

      		this.totalPrice = this.report[0].price;
			this.report.forEach((item, index) => {
				this.chartData.labels.push(item.eqid);
				this.chartData.datasets[0].data.push(item.price);
				this.chartData.datasets[0].backgroundColor.push(this.getColor(index));
			});

			if (this.start) {
				setTimeout(() => {
				this.openSlice(0);
				}, 1800);
			}
		},
    handleGraphHover(evt) {
		const point = this.$refs.chart.chart.getElementAtEvent(evt);
			if (point.length) {
				evt.target.style.cursor = 'pointer';
			}
		},
		handleGraphClick(evt) {
			const activeElement = this.$refs.chart.chart.getElementAtEvent(evt);
			if (activeElement[0] !== undefined) {
				this.openSlice(activeElement[0]._index);
			}
		},
		openSlice(sliceIndex) {
			if (this.selectable === true) {
				const chart = this.$refs.chart.chart;
				chart.update();
				const meta = chart.data.datasets[0]._meta;
				const assetType = this.report[sliceIndex].eqidDef;
				const assetName = chart.data.labels[sliceIndex];
				this.onSelect(assetType, assetName);
				this.totalPrice = this.report[sliceIndex].price
				const slices = meta[Object.keys(meta)[0]].data;
					if (slices[sliceIndex]) {
						const sliceModel = slices[sliceIndex]._model;
						if (this.inline) {
						sliceModel.outerRadius += 5;
						sliceModel.innerRadius += 3;
					} else {
						sliceModel.outerRadius += 13;
						sliceModel.innerRadius += 10;
					}
				}
				this.start = false;
			}
		},
		getName(name) {
			const i = name.indexOf("/");
			if (i > 0) {
				return name.slice(0, i) + '/ ' + name.slice(i + 1, name.length);
			} else {
				return name;
			}
		}
	},
	data() {
		return {
      		start: true,
			totalPrice: 0,
			chartData: {
				labels: [],
				datasets: [
					{
						data: [],
						backgroundColor: [],
						borderWidth: 0
					},
				],
			},
			options: {
				responsive: true,
				cutoutPercentage: 70,
				legend: false,
				title: false,
				tooltips: false,
				hover: {
					mode: null,
                    onHover: this.handleGraphHover
				},
				animation: {
					animateScale: true,
					animateRotate: true,
				},
				onClick: this.handleGraphClick,
				layout: {
					padding: this.inline ? 5 : 15,
				}
			},
			colors: ["#bbcf2c", "#058dcc", "#6e548d", "#818181", "#ebebeb", "#13516e"],
		};
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.assets-composition-wrapper {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;

	&.chart-wrapper-inline {
		flex-direction: row;
	}

	&:not(.chart-wrapper-inline) {
		.chart-wrapper {
			margin: 0 auto 20px;
		}

		.legend-wrapper {
			max-width: 250px;
			margin: 0 auto;
		}
	}

	.legend-wrapper {
		display: flex;
		width: 100%;
		align-self: stretch;
		padding-left: 15px;
		align-items: center;

		ul {
			list-style: none;
			padding: 0;
			margin: 0;
			font-size: 13px;
			//line-height: 170%;
			color: $secondary-text;
			width: 100%;

			li {
				display: block;
				width: 100%;

				.dot {
					$dotSize: 8px;
					float: left;
					display: block;
					width: $dotSize;
					height: $dotSize;
					border-radius: 50%;
					margin-right: 7px;
					margin-top: 7px;
				}

				.percent {
					float: right;
				}
			}

            li:last-child {
                .dot {
                    margin-bottom: 5px;
                }
            }
		}
	}

	.chart-wrapper {
		position: relative;

		.total-wrapper {
			$totalWrapperMargin: 15%;
			position: absolute;
			top: $totalWrapperMargin;
			right: $totalWrapperMargin;
			bottom: $totalWrapperMargin;
			left: $totalWrapperMargin;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			text-align: center;
			color: $secondary-text;
			font-size: 15px;
			padding: 10px;
			line-height: 110%;
		}
	}
}
</style>
